import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthenticateTokenComponent } from './authenticate-token.component';

@NgModule({
  declarations: [
    AuthenticateTokenComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    AuthenticateTokenComponent
  ],
  entryComponents: [
    AuthenticateTokenComponent
  ]
})
export class AuthenticateTokenModule { }
